import { formatNumber, Page, Separator } from '@acme/foundation';
import { LiquidityProvidersTable } from '@widgets/providersTable';
import { Alert, Button, Card, Progress } from 'flowbite-react';
import { useApplicationProvidersPage } from '../lib';
import { ApplicationProvidersDealTable } from './offers';

export const ApplicationLiquidityProvidersPage = () => {
  const {
    submitError,
    application,
    agentContract,
    liquidityProviders,
    isLoading,
    currentAmount,
    orderAmount,
    isDisabled,
    breadcrumbItems,
    dealParticipantRows,
    handleSelectProviders,
    handleSelectProvider,
    handleChangePendingAmount,
    handleRemovePending,
    contract,
  } = useApplicationProvidersPage();

  const requiredAmount =
    agentContract?.cryptoAmount ?? contract?.cryptoAmount ?? 0;
  const totalSelected = currentAmount + orderAmount;
  const progressPercent =
    requiredAmount > 0
      ? Math.min(100, Math.round((totalSelected / requiredAmount) * 100))
      : 0;
  const displayCurrency =
    agentContract?.cryptoCurrency?.name ??
    (contract?.cryptocurrency as { name?: string } | undefined)?.name ??
    '';

  return (
    <Page breadcrumbItems={breadcrumbItems} isLoading={isLoading}>
      {submitError && (
        <Alert color="failure" className="mb-4">
          {submitError}
        </Alert>
      )}
      <Card>
        <div className="flex justify-between font-semibold text-xl">
          <h2>{`${application?.code} - ${application?.name}`}</h2>

          <div className="flex flex-col gap-1 min-w-0">
            <div className="flex items-center gap-2">
              <div className="font-semibold text-gray-900">{`${formatNumber(totalSelected)} из ${formatNumber(requiredAmount)}`}</div>
              <span className="text-gray-500 shrink-0">{displayCurrency}</span>
            </div>
            <Progress
              progress={progressPercent}
              color="purple"
              size="sm"
              className="w-full"
            />
          </div>
        </div>
        <Separator className="-mx-6" />
        <ApplicationProvidersDealTable
          rows={dealParticipantRows}
          onChangeAmount={handleChangePendingAmount}
          onRemove={handleRemovePending}
        />
        <Separator className="-mx-6" />
        <div className="flex justify-end">
          <Button
            disabled={isDisabled}
            onClick={handleSelectProviders}
            color="primary"
          >
            Заказать
          </Button>
        </div>
      </Card>

      <Card>
        <LiquidityProvidersTable
          className="-mx-6"
          providers={liquidityProviders}
          selectProvider={handleSelectProvider}
        />
      </Card>
    </Page>
  );
};
